

function getCenter(pathEl) {
  const bbox = pathEl.getBBox();
  return {
    x: bbox.x + bbox.width / 2,
    y: bbox.y + bbox.height / 2
  };
}

export function addAttack(svgEl, fromPath, toPath, uid) {
const c1 = getCenter(fromPath);
  const c2 = getCenter(toPath);

  // Directional bezier control points (slight curve in direction of target)
  const dx = c2.x - c1.x;
  const dy = c2.y - c1.y;
  const controlOffset = 0.2 * dx;

  const cp1 = { x: c1.x + controlOffset, y: c1.y - 20 };
  const cp2 = { x: c2.x - controlOffset, y: c2.y - 20 };

  // Create attack curve path
  const curve = document.createElementNS("http://www.w3.org/2000/svg", "path");
  curve.setAttribute("id", "attackPath" + uid);
  const d = `M ${c1.x} ${c1.y} C ${cp1.x} ${cp1.y}, ${cp2.x} ${cp2.y}, ${c2.x} ${c2.y}`;
  curve.setAttribute("d", d);
  curve.setAttribute("stroke", "#fff");
  curve.setAttribute("stroke-width", "2");
  curve.setAttribute("fill", "none");
  curve.setAttribute("marker-end", "url(#arrow)");

  svgEl.insertBefore(curve, svgEl.lastChild); // ensure path is under dot



  const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  circle.setAttribute("id", "movingDot" +uid )
  circle.setAttribute("r", "2")
  circle.setAttribute("fill", "purple")
  //<circle style="z-index: 10;" id="movingDot" r="5" fill="crimson"
  circle.innerHTML = `>
    <animateMotion dur="${Math.floor(Math.random()*5 + 1)}s" repeatCount="indefinite">
      <mpath href="#attackPath${uid}"/>
    </animateMotion>
  `
  svgEl.insertBefore(circle, svgEl.lastChild);

  }
